
import propTypes from 'prop-types'
import {  Input } from '@progress/kendo-react-inputs';

const MyInput = (props) => {

    return (
        <div className="form-group">
            {props.label &&
                <label style={props.labelStyle}>{props.label}</label>
            }
            <div>
                <Input 
                    {...props.props} 
                    required={props.required} 
                    name={props.name} 
                    onChange={props.onChange} 
                    onBlur={props.onBlur} 
                    value={props.value} 
                    style={{ width: "100%", borderColor: props.error ? '#dc3545' : '#ccc' }} 
                    type={props.type} 
                    disabled={props.disabled}
                />
                {props.error && (
                    <div className="text-danger small" style={{ marginTop: '4px' }}>{props.error}</div>
                )}
            </div>
        </div>
    );
};

MyInput.propTypes = {
    onChange: propTypes.func,
    error: propTypes.string
};

export default MyInput;
